var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouthMedicalRecordNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542593491,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 62611,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M834.4 209.2c-46.1-99.3-170.1-130.8-290-99.1-11.1 2.6-21.7 4.2-31.5 4.5-10.6-0.5-21.1-2-31.5-4.5-119.8-31.7-243.8-0.2-290 99.1-70.4 151.9 125.8 232.4 84.9 405.4-38.2 162.3 59.5 268.7 89.5 292.9 30.1 24.3 76.4 32.9 68.6-5.9-30.1-150.1 26.5-223.3 59.1-251.1 4.8-4.1 12.1-6.2 19.3-6.2 7.3 0 14.5 2 19.4 6.2 32.7 27.8 89.2 101 59.2 251.1-7.8 38.8 38.6 30.2 68.6 5.9 30-24.3 127.8-130.7 89.4-292.9-40.7-173 155.4-253.5 85-405.4z",
    "p-id": 62612,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthMedicalRecordNum);
export default __webpack_public_path__ + "static/media/mouthMedicalRecordNum.31081889.svg";
export { ForwardRef as ReactComponent };